import React, {useEffect, useState} from 'react'
import {useSelector} from "react-redux";
import axios from "axios";
import classNames from "classnames";

export default function ChatPreview({imageMap, data, onModalClose}) {
    const isPreview = useSelector(state => state.isPreview)
    const isBoothEditor = useSelector(state => state.isBoothEditor)

    if (isPreview || isBoothEditor) {
        return null
    }

    const getAppointmentDataUrl = useSelector(state => state.getAppointmentDataUrl)
    const createAppointmentUrl = useSelector(state => state.createAppointmentUrl)
    const deleteAppointmentUrl = useSelector(state => state.deleteAppointmentUrl)

    const [isLoading, setIsLoading] = useState(true)
    const [selectedAppointment, setSelectedAppointment] = useState([])
    const [availableAppointments, setAvailableAppointments] = useState([])
    const [bookedAppointments, setBookedAppointments] = useState([])
    const [showModal, setShowModal] = useState(false)

    const groupedByDay = _.chain(availableAppointments)
      .groupBy("day")
      .sortBy((value, key) => value[0].day)
      .value()

    const loadAppointmentData = () => {
        if (getAppointmentDataUrl) {
            axios({
                method: "post",
                url: getAppointmentDataUrl,
                data: {
                    image_map_id: imageMap.id
                }
            }).then(
              (data) => {
                  if (data.data.status === "OK") {
                      setBookedAppointments(data.data.booked_appointments)
                      setAvailableAppointments(data.data.available_appointment_slots)
                      setSelectedAppointment(null)
                  } else {
                      alert(data.data.message || "A error occurred while confirming your appointment.")
                  }
              },
              (error) => {
                  console.error(error)
                  alert(error)
              }).then(function () {
                setIsLoading(false)
            });
        }
    }

    useEffect(() => {
        loadAppointmentData()
    }, [])

    const confirmAppointment = (timeslot) => {
        setIsLoading(true)

        axios({
            method: "post",
            url: createAppointmentUrl,
            data: {
                image_map_id: imageMap.id,
                timeslot: selectedAppointment
            }
        }).then(
          (data) => {
              if (data.data.status === "OK") {
                  setBookedAppointments(data.data.booked_appointments)
                  setAvailableAppointments(data.data.available_appointment_slots)
                  setSelectedAppointment(null)
              } else {
                  loadAppointmentData()
                  alert(data.data.message || "A error occurred while confirming your appointment.")
              }
          },
          (error) => {
              console.error(error)
              alert(error)
          }).then(function () {
            setIsLoading(false)
        })
    }

    const cancelAppointment = (timeslot) => {
        setIsLoading(true)

        axios({
            method: "delete",
            url: deleteAppointmentUrl,
            data: {
                image_map_id: imageMap.id
            }
        }).then(
          (data) => {
              if (data.data.status === "OK") {
                  setBookedAppointments(data.data.booked_appointments)
                  setAvailableAppointments(data.data.available_appointment_slots)
                  setSelectedAppointment(null)
              } else {
                  loadAppointmentData()
                  alert(data.data.message || "A error occurred while confirming your appointment.")
              }
          },
          (error) => {
              console.error(error)
              alert(error)
          }).then(function () {
            setIsLoading(false)
        })
    }

    const selectAppointment = (timeslot) => {
        setSelectedAppointment(timeslot)
    }

    const timeslotToDisplayTime = (timeslot) => {
        return `${timeslot.hour.toString().padStart(2, "0")}:${timeslot.minute.toString().padStart(2, "0")} - ${timeslot.hour.toString().padStart(2, "0")}:${(timeslot.minute + 14).toString().padStart(2, "0")} CET`
    }

    const Loading = () => {
        return <div className={"text-center"}>
            <div className="spinner-border text-dark" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    }

    const Appointments = () => {
        return <>
            <p>Please select date and time below to book an appointment:</p>
            {groupedByDay.map((group, day) => {
                let groupedByHour = _.chain(group)
                  .groupBy("hour")
                  .sortBy((value, key) => value[0].hour)
                  .value()

                return <div key={group[0].day}>
                    <h5>{group[0].day}. October</h5>
                    {groupedByHour.map((group, hour) => {
                        const sortedByMinute = _.sortBy(group, ["minute"])

                        return <div key={group[0].hour}>
                            <strong>{group[0].hour} o'clock</strong>
                            <div>
                                {sortedByMinute.map((timeslot) => <div
                                  key={timeslot.minute}
                                  onClick={() => selectAppointment(timeslot)}
                                  className={classNames("appointment-timeslot")}>
                                    {timeslotToDisplayTime(timeslot)}
                                </div>)}
                            </div>
                            <hr/>
                        </div>
                    })}
                </div>
            })}
        </>
    }

    const AppointmentConfirmation = () => {
        return <>
            <p>Please confirm your appointment:</p>
            <strong>Day {selectedAppointment.day} - {timeslotToDisplayTime(selectedAppointment)}</strong>
            <hr/>
            <div className="text-center">
                <button
                  onClick={confirmAppointment}
                  className={classNames("btn btn-outline-success m-2")}>CONFIRM</button>
                <button
                  onClick={() => setSelectedAppointment(null)}
                  className={classNames("btn btn-outline-dark m-2")}>CANCEL</button>
            </div>
        </>

    }

    const ModalBody = () => {
        if (isLoading) {
            return <Loading/>
        } else if (!_.isEmpty(bookedAppointments)) {
            return <>
                <p>You have a booked appointment at:</p>
                {bookedAppointments.map(timeslot => <div>
                    <strong>Day {timeslot.day} - {timeslotToDisplayTime(timeslot)}</strong>
                </div>)}
                <hr/>

                <div className="text-center">
                    <button
                      onClick={cancelAppointment}
                      className={classNames("btn btn-outline-danger")}>CANCEL APPOINTMENT</button>
                </div>
            </>
        } else if (selectedAppointment) {
            return <AppointmentConfirmation/>
        } else if (_.isEmpty(groupedByDay)) {
            return <p>Currently no time slots are available.</p>
        }

        return <Appointments/>;
    }

    return <div className="modal preview-modal" role="dialog" tabIndex="-1"
                onClick={() => {
                    onModalClose ? onModalClose() : alert("No modal close action available.")
                }}>
        <div className="modal-dialog" role="document">
            <div className="modal-content" onClick={(event) => {
                event.stopPropagation()
            }}>
                <div className="modal-header">
                    <div className="modal-title">
                        {data.title}
                    </div>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                          onModalClose ? onModalClose() : alert("No modal close action available.")
                      }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <ModalBody/>
                </div>
            </div>
        </div>
    </div>;
}